import './App.css';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import {Link,withRouter} from "react-router-dom";
import Login from "./components/login";
import React, { Component} from 'react';
import Cookies from 'universal-cookie';
import raw from "./api.txt";
const cookies=new Cookies();
//import ReactTooltip from 'react-tooltip';
class App extends Component {
  constructor(props){
    super(props);
      this.state={comp:<Login/>}   
  }
  componentDidMount()
  {
    this.props.history.push({
      pathname: "./login"

    }    )
    fetch(raw)
      .then(r => r.text())
        .then(apipath => {
          cookies.set('phpclass', apipath, { path: '/' });       
//          alert(text);
      });
//    cookies.set('phpclass', "https://d-land.pk/ci2", { path: '/' });       
//    cookies.set('phpclass', "https://d-land.pk/ci2", { path: '/' });       

//    cookies.set('phpclass', "/ci2", { path: '/' });       
//    cookies.set('phpclass', "", { path: '/' });       
    
//    cookies.set('phpclass', "https://poultry-kandns.com", { path: '/' });       
//    cookies.set('phpclass', "..", { path: '/' });       

    //let URLlength = window.location.pathname.length;
//    if(URLlength > 7)
 //   {
//      this.setState({comp:""})
//    }
   }
    
  render(){
      return(

        <React.Fragment>
        <nav className="navbar navbar-expand navbar-light navbar-custom ">
            <div className="container1">
{/*}              <div className="collapse navbar-collapse" id="navbarTogglerDemo02">*/}
                <ul className="navbar-nav mr-auto">
                  <li className="nav-item">
                    <Link className="nav-link" to={"/login"}  onClick={() => {this.setState({comp:""})}} >Login</Link>
{/*}                    <ReactTooltip id="rTip" place="top" effect="solid"> Tooltip for the register button</ReactTooltip>*/}

                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to={"/signup"} onClick={() => {this.setState({comp:""})}}>Sign up</Link>
                  </li>
                </ul>
               </div>
              {/* </div>*/}
              </nav>
            {/*}  <Login/>*/}
            </React.Fragment>
      );
  }
}
export default withRouter(App);
